import { turkishInitials } from '@custel/turkish';
import { useTranslation } from 'react-i18next';
import { cn } from '../../lib/cn';

/**
 * Avatar — BRANDBOOK §6.16 (Sprint 28c hed_v3, C3C kararı).
 *
 * KVKK kararı: foto upload yok, sadece initials.
 *   - Default: krem bg + ink text + g200 ring.
 *   - current=true: ink bg + lime text (sidebar footer "ben" göstergesi).
 *
 * Sizes: sm 24, md 32, lg 40, xl 64. Legacy `xs` md'ye remap edilir.
 */

interface AvatarProps {
  name?: string;
  /** Legacy — yeni component foto kullanmaz. Geriye dönük uyumluluk için tutuldu, görmezden gelinir. */
  src?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  current?: boolean;
  className?: string;
}

const sizeClass: Record<NonNullable<AvatarProps['size']>, string> = {
  xs: 'h-6 w-6 text-[10px]',
  sm: 'h-6 w-6 text-[10px]',
  md: 'h-8 w-8 text-[12px]',
  lg: 'h-10 w-10 text-[14px]',
  xl: 'h-16 w-16 text-[22px]',
};

export function Avatar({ name = '', size = 'md', current, className }: AvatarProps) {
  const { t } = useTranslation('components');
  const label = turkishInitials(name);
  return (
    <span
      data-current={current ? 'true' : undefined}
      className={cn(
        'inline-flex shrink-0 select-none items-center justify-center rounded-full border font-semibold uppercase tracking-tight',
        // Default — krem bg + ink text + g200 border
        'border-custel-border bg-custel-krem text-custel-ink',
        // Current — ink bg + lime text
        'data-[current=true]:border-custel-ink data-[current=true]:bg-custel-ink data-[current=true]:text-custel-lime',
        sizeClass[size],
        className,
      )}
      aria-label={name || t('avatar.user')}
      role="img"
    >
      {label}
    </span>
  );
}
